import { api, mainApi } from '@/lib/api/http'
import { endpoints, mainEndpoints } from '@/lib/api/endpoints'
import type {
  ChangePasswordPayload,
  LoginCredentials,
  LoginResponse,
  MainApiProfile,
} from '@/features/auth/types'

export const authApi = {
  /** `POST /v1/auth/login` — public. `rememberMe` is client-side only. */
  login({ email, password }: LoginCredentials): Promise<LoginResponse> {
    return api.post<LoginResponse>(endpoints.auth.login, { email, password }, { skipAuth: true })
  },

  // `POST /v1/auth/refresh` is deliberately absent here. The service rotates the
  // refresh token on every call, so there must be exactly one way to spend one:
  // `refreshAccessToken()` in `lib/api/http.ts`, which is single-flight and
  // writes the rotated token back to storage. A second binding on this object
  // would be an easy way to reintroduce a session that dies on its first reload.

  /** `POST /v1/auth/logout` — revokes the refresh token server-side. Returns 204. */
  logout(refreshToken: string): Promise<void> {
    return api.post<void>(endpoints.auth.logout, { refreshToken })
  },

  /**
   * `GET /v1/profiles` — on the MAIN API, not the auth service. Returns the
   * service's own shape; `toUserProfile` folds it into the app's user model.
   */
  profile(): Promise<MainApiProfile> {
    return mainApi.get<MainApiProfile>(mainEndpoints.profile)
  },

  /** `POST /v1/auth/change-password` — revokes every refresh token on success. */
  changePassword(payload: ChangePasswordPayload): Promise<void> {
    return api.post<void>(endpoints.auth.changePassword, payload)
  },
}
